import React from "react";
import RootLayout from "./RootLayout";
import whiteLogo from "../assets/images/logo-new.png";
import { Layout, Menu, Breadcrumb, Tooltip, Button, Icon } from "antd";
import { TTranslate } from "../../service/locale/TranslationService";
import { TPresentable } from "../../presenter/withStore";
import { IMenuItem } from "../../model/menu/MenuItem";
import { SubMenu } from "rc-menu";
import { ILanguage } from "../../model/language/Language";
import Application from "../../Application";
import ChangeLanguageInteractor from "../../interactor/settings/ChangeLanguageInteractor";
import ShowSuccessMessageInteractor from "../../interactor/notifications/ShowSuccessMessageInteractor";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import Link from "../components/app/Link";
import PortalMobileMenu from "./components/PortalMobileMenu";

const { Header, Content, Footer } = Layout;

export interface Props {
  router: any;
  children?: any;
  translate: TTranslate;
}

export interface State extends TPresentable {
  collapsed: boolean;
  selectedMenuItem: IMenuItem;
  selectedPath: string;
  mobileMenuVisible: boolean;
}

export default class AppLayout extends React.Component<Props, State> {
  private subscriptionId: number = 0;
  constructor(props) {
    super(props);
    this.state = { ...props };
    this.setState({ collapsed: false, mobileMenuVisible: false });
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { children, translate } = this.props;

    const {
      languages,
      application,
      selectedLanguage,
      mobileMenuVisible
    }: {
      languages: ILanguage[];
      application: Application;
      selectedLanguage: ILanguage;
      mobileMenuVisible: boolean;
    } = this.state as any;

    let { menuItems = [] }: { menuItems: IMenuItem[] } = this.state as any;

    menuItems = menuItems.sort((a, b) => a.rbr - b.rbr);

    const logoOnClickLink = "https://www.pravosudje.ba/";
    const redirect = (path: string) => {
      window.location.href = path;
      this.setState({
        selectedPath: path
      });
    };

    const onSelectMenuItem = (menuItem: IMenuItem) => {
      redirect(menuItem.url);
      this.setState({
        selectedMenuItem: menuItem
      });
    };

    const renderMenuItem = (menuItem: IMenuItem) => {
      return menuItem.children.length ? (
        <SubMenu
          key={menuItem.id}
          title={<span className="submenu-title-wrapper">{menuItem.name}</span>}
        >
          {menuItem.children
            .sort((a, b) => a.rbr - b.rbr)
            .map((child) => renderMenuItem(child))}
        </SubMenu>
      ) : (
        <Menu.Item
          key={menuItem.id}
          style={{ flex: 1, flexDirection: "column" }}
        >
          <Tooltip title={menuItem.description}>
            <Link onClick={() => onSelectMenuItem(menuItem)}>
              {menuItem.name}
            </Link>
          </Tooltip>
        </Menu.Item>
      );
    };

    const renderLanguageSubmenuItems = (languages: ILanguage[]) => {
      let languageItems: JSX.Element[] = [];

      languages?.forEach((language: ILanguage) => {
        languageItems.push(
          <Menu.Item
            onClick={() => changeLanguage(language)}
            key={language.code}
          >
            {language.name}
          </Menu.Item>
        );
      });
      return languageItems;
    };

    const changeLanguage = async (language: ILanguage) => {
      try {
        await application.container
          .resolve<ChangeLanguageInteractor>("changeLanguage")
          .execute(language.code, true);
        application.changeSystemLanguage(language.code);
        window.location.reload();
        application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(translate("change_language_form.messages.change_success"));
      } catch (error) {
        application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const showMobileMenu = () => {
      this.setState({ mobileMenuVisible: true });
    };

    const hideMobileMenu = () => {
      this.setState({ mobileMenuVisible: false });
    };

    const nShowMobileMenuBtnClick = () => {
      const { mobileMenuVisible } = this.state;

      if (mobileMenuVisible) {
        hideMobileMenu();
      } else {
        showMobileMenu();
      }
    };

    return (
      <RootLayout {...this.props}>
        <div className="base_layout">
          <Layout style={{ minHeight: "100vh" }}>
            <Header
              className="header desktop-header"
              style={{ position: "fixed", zIndex: 2, width: "100%" }}
            >
              <div className="logo">
                <a href={logoOnClickLink} target={"_blank"}>
                  <img src={whiteLogo} alt="Logo" />
                </a>
              </div>
              <Menu
                theme="dark"
                mode="horizontal"
                style={{ lineHeight: "64px" }}
              >
                <Menu.Item key={"0"}>
                  <Link onClick={() => redirect("/home")}>
                    {translate("portal_office_layout.home")}
                  </Link>
                </Menu.Item>
                {(menuItems || []).map(
                  (menuItem) => menuItem.valid && renderMenuItem(menuItem)
                )}

                <SubMenu
                  style={{ float: "right" }}
                  title={selectedLanguage?.name}
                >
                  {renderLanguageSubmenuItems(languages)}
                </SubMenu>
              </Menu>
            </Header>
            <Header
              className="header mobile-header"
              style={{ position: "fixed", zIndex: 2, width: "100vw" }}
            >
              <div className="logo">
                <a href={logoOnClickLink} target={"_blank"}>
                  <img src={whiteLogo} alt="Logo" />
                </a>
              </div>
              <Button
                className={"show-menu-btn"}
                type={"primary"}
                onClick={() => nShowMobileMenuBtnClick()}
              >
                <Icon type="menu" />
              </Button>
            </Header>
            <Layout style={{ marginTop: 64 }}>
              <PortalMobileMenu
                translate={translate}
                menuItems={menuItems}
                onSelectMenuItem={onSelectMenuItem}
                selectedLanguage={selectedLanguage}
                changeLanguage={changeLanguage}
                languages={languages}
                visible={mobileMenuVisible}
                onClose={hideMobileMenu}
              />
              <Layout style={{ padding: "0 24px 24px" }}>
                {!(
                  this.state.selectedPath !== "/" &&
                  this.state.selectedPath !== "/home"
                ) ? (
                  <Breadcrumb style={{ margin: "16px 0", fontWeight: "bold" }}>
                    <Breadcrumb.Item>
                      {this.state.selectedMenuItem &&
                        this.state.selectedMenuItem.name}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                ) : undefined}
                <Content
                  style={{
                    background: "#fff",
                    padding: 24,
                    margin: 0,
                    minHeight: 280
                  }}
                >
                  {children}
                </Content>
                <Footer style={{ textAlign: "center" }}>
                  {`© ${new Date().getFullYear()} Visoko sudsko i tužilačko vijeće`}
                </Footer>
              </Layout>
            </Layout>
          </Layout>
        </div>
      </RootLayout>
    );
  }
}
